import { render, staticRenderFns } from "./QuotationChat.vue?vue&type=template&id=18ce1b6a&"
import script from "./QuotationChat.vue?vue&type=script&lang=js&"
export * from "./QuotationChat.vue?vue&type=script&lang=js&"
import style0 from "./QuotationChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports